var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lower-bar-lite lower-bar-lite-grid" },
    [
      _vm.routeCheck
        ? _c("ResultMaterialsCard", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isVisibleMaterialList,
                expression: "isVisibleMaterialList"
              }
            ],
            staticClass: "result-card-container",
            attrs: {
              designId: _vm.designId,
              designMaterialChanged: _vm.designMaterialChanged,
              id: "result-materials-list"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "lite-result-info" }, [
        _c("div", { staticClass: "result-info-design-name-grid" }, [
          _c("div", { staticClass: "result-info-design-name-label" }, [
            _vm._v("\n                    Дизайн:\n                ")
          ]),
          _vm._v(" "),
          _vm.designMaterialChanged > 0
            ? _c("div", { staticClass: "result-info-design-name" }, [
                _vm._v(
                  "\n                    Пользовательский\n                "
                )
              ])
            : _c("div", { staticClass: "result-info-design-name" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.selectedDesign.designName) +
                    "\n                "
                )
              ])
        ]),
        _vm._v(" "),
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "result-info-design-name-grid clickable",
            attrs: { id: "result-materials-list-switcher" },
            on: {
              click: function($event) {
                return _vm.switchVisibleMaterialList()
              }
            }
          },
          [
            _c("div", { staticClass: "result-info-design-name" }, [
              _vm._v(
                "\n                    Список материалов\n                "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-center" },
              [
                _vm.isVisibleMaterialList
                  ? _c("SVGArrowUp", { staticClass: "result-info-arrow-svg" })
                  : _c("SVGArrowDown", { staticClass: "result-info-arrow-svg" })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lite-result-buttons-grid" }, [
        _c(
          "div",
          {
            staticClass: "gl-square-btn btn-grey",
            on: {
              click: function($event) {
                return _vm.showModal("modal-request-custom-design")
              }
            }
          },
          [
            _vm._v(
              "\n                Применить выбранный дизайн на свой дом\n            "
            )
          ]
        ),
        _vm._v(" "),
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "gl-square-btn btn-red",
            on: {
              click: function($event) {
                return _vm.showModal("modal-get-price")
              }
            }
          },
          [
            _vm._v(
              "\n                Узнать цену для своего дома\n            "
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }